import React from "react";
import {
    useState
} from "react";
import {
    useToolsPage
} from "./hooks";
import Form from "react-bootstrap/Form";
import Card from 'react-bootstrap/Card';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Placeholder from 'react-bootstrap/Placeholder';
import Image from 'react-bootstrap/Image';
import Button from 'react-bootstrap/Button';
import {
    Link
} from "react-router-dom";
import { useEffect } from "react";

import ReactCommonmark from "react-commonmark";

function ToolsPage(props) {
    const [query, setQuery] = useState("");
    const [order, setOrder] = useState("lastExecutedByTeamAt");
    const [loading, setLoading] = useState(true);
    return (
        <>
            <Row className="mb-3 mt-3">
                <Col xs={12} md={8}>
                    <Form.Control
                        type="text"
                        placeholder="Keyword Search Query"
                        disabled={loading}
                        onBlur={e => setQuery(e.target.value)}
                        onKeyUp={e => {
                            if (e.key === "Enter") {
                                e.target.blur();
                            }
                        }}
                    />
                </Col>
                <Col xs={12} md={4}>
                    <Form.Select
                        disabled={loading}
                        onChange={e => setOrder(e.target.value)}
                    >
                        <option value="lastExecutedByTeamAt">Sorted by Last Executed by Team</option>
                        <option value="lastExecutedByMeAt">Sorted by Last Executed by Me</option>
                        <option value="name">Sorted by Name</option>
                    </Form.Select>
                </Col>
            </Row>
            <ToolList
                query={query}
                order={order}
                onLoading={(loading) => {
                    setLoading(loading);
                }}
            />
        </>
    );
}

function ToolList(props) {
    const { query, order, onLoading } = props;

    // eslint-disable-next-line no-unused-vars
    const [cursor, setCursor] = useState(null);
    // eslint-disable-next-line no-unused-vars
    const [loading, data, error] = useToolsPage(query, order, cursor);

    useEffect(function () {
        onLoading(loading);
    }, [loading]);

    return (
        <div className="tools-container">
            {loading
                ? [1, 2, 3].map(i => <ToolPlaceholder />)
                : data.items.map(ti => <ToolCard
                    key={ti.id}
                    id={ti.id}
                    name={ti.name}
                    description={ti.description}
                    ownerId={ti.owner.id}
                    ownerUsername={ti.owner.username}
                    ownerPicture={ti.owner.picture}
                />)
            }
        </div>
    );
}

function ToolPlaceholder(props) {
    const avatar = <Image
        src="/images/avatar.png"
        roundedCircle={true}
        fluid={true}
        style={{ width: "18px", height: "18px" }}
    />;
    return (
        <Card className="mb-3">
            <Card.Header>
                <Container>
                    <Row>
                        <Col>
                            {avatar}
                            {" "}
                            <Placeholder as="span" animation="wave">
                                <Placeholder xs={3} size="lg" />
                            </Placeholder>
                        </Col>
                        <Col xs={2} style={{ textAlign: "right" }}>
                            <Button
                                variant="primary"
                                size="sm"
                                disabled={true}
                            >
                                Run this tool
                            </Button>
                        </Col>
                    </Row>
                </Container>
            </Card.Header>
            <Card.Body>
                { /* <Card.Title>Special title treatment</Card.Title> */}
                <Card.Text>
                    <Placeholder as="p" animation="wave">
                        <Placeholder xs={12} size="lg" />
                    </Placeholder>
                </Card.Text>
                { /* <Button variant="primary">Go somewhere</Button> */}
            </Card.Body>
        </Card>
    );
}

function ToolCard(props) {
    const {
        id,
        name,
        description,
        ownerUsername,
        ownerPicture
    } = props;

    const avatar = <Image
        src={ownerPicture}
        roundedCircle={true}
        fluid={true}
        style={{ width: "18px", height: "18px" }}
        onError={e => {
            e.target.src = "/images/avatar.png";
        }}
    />;

    return (
        <Card className="mb-3">
            <Card.Header>
                <Container>
                    <Row>
                        <Col>
                            <Link to={`/team/${ownerUsername}`}>
                                {avatar}
                            </Link>
                            &nbsp;
                            <Link to={"/tools/" + id}>{name}</Link>
                        </Col>
                        <Col xs={2} style={{ textAlign: "right" }}>
                            <Button
                                as={Link}
                                variant="primary"
                                size="sm"
                                to={"/tools/" + id + "/execute"}
                            >
                                Run this tool
                            </Button>
                        </Col>
                    </Row>
                </Container>
            </Card.Header>
            <Card.Body>
                { /* <Card.Title>Special title treatment</Card.Title> */}
                <Card.Text>
                    { /* TODO Fix CommonMark */ }
                    <ReactCommonmark source={description} />
                </Card.Text>
                { /* <Button variant="primary">Go somewhere</Button> */}
            </Card.Body>
        </Card>
    );
}

export default ToolsPage;